import { useState } from 'react'
import { useInstallPrompt } from '../hooks/useInstallPrompt'
import { Button } from './ui/Button'

/**
 * Install prompt banner for PWA Add to Home Screen
 * Mobile-first design with large touch targets
 */
export function InstallPrompt() {
  const { isInstallable, promptInstall, dismissPrompt } = useInstallPrompt()
  const [isInstalling, setIsInstalling] = useState(false)

  if (!isInstallable) {
    return null
  }

  const handleInstall = async () => {
    setIsInstalling(true)
    try {
      await promptInstall()
    } finally {
      setIsInstalling(false)
    }
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t border-gray-200 shadow-lg safe-area-pb">
      <div className="max-w-lg mx-auto">
        <div className="flex items-start gap-4">
          {/* App icon */}
          <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-[#1e3a5f] flex items-center justify-center">
            <svg
              className="w-8 h-8 text-amber-400"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
            </svg>
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <h3 className="text-base font-semibold text-gray-900">
              Install RoadeoScoring
            </h3>
            <p className="text-sm text-gray-600 mt-0.5">
              Add to home screen for quick access and offline scoring
            </p>
          </div>

          {/* Close button */}
          <button
            onClick={dismissPrompt}
            className="flex-shrink-0 p-2 -m-2 text-gray-400 hover:text-gray-600 active:scale-95 transition-transform"
            aria-label="Dismiss"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Action buttons */}
        <div className="flex gap-3 mt-4">
          <Button
            variant="outline"
            onClick={dismissPrompt}
            className="flex-1"
          >
            Not Now
          </Button>
          <Button
            onClick={handleInstall}
            isLoading={isInstalling}
            className="flex-1"
          >
            Install
          </Button>
        </div>
      </div>
    </div>
  )
}
